import { CommitmentsVersionsSensitiveService_commitmentVersionsSensitiveServiceGetEntity } from '@festina/life-general-types/life/hooks/CommitmentsVersionsSensitiveService_commitmentVersionsSensitiveServiceGetEntity'

export const useLazyFetchCommitmentVersionSensitive =
  CommitmentsVersionsSensitiveService_commitmentVersionsSensitiveServiceGetEntity.useLazyQuery
